// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-leftsidemenu-container{box-shadow:3px 0px 3px 1px rgba(0,0,0,0.1);min-width:200px;width:200px}@media print{.layout-leftsidemenu-container{display:none}}.left-side-menu-navigation{min-height:3em}.location-switcher{transition:all 100ms ease-out;color:#0af}.location-switcher:hover,.location-switcher:focus{color:#80d5ff}.location-switcher:active{color:#0077b3}\n", ""]);
// Exports
module.exports = exports;
